import { z } from 'zod';


const bulkCreateHolidayBaseSchema = z.object({
  holidayTypeId: z.union([
    z.coerce.number({ invalid_type_error: 'common:validation.invalidValue' }).int().positive(),
    z.null(),
  ]),
  year: z.union([
    z.coerce.number({ invalid_type_error: 'common:validation.invalidValue' }).int().min(2000),
    z.null(),
  ]),
  weekdays: z.array(z.number().int().min(1).max(7)),
});

export const bulkCreateHolidaySchema = bulkCreateHolidayBaseSchema
  .refine((data) => data.holidayTypeId !== null, {
    message: 'attendance:holiday.validation.holidayTypeRequired',
    path: ['holidayTypeId'],
  })
  .refine((data) => data.year !== null, {
    message: 'attendance:holiday.validation.yearRequired',
    path: ['year'],
  })
  .refine((data) => data.weekdays.length > 0, {
    message: 'attendance:holiday.validation.weekdaysRequired',
    path: ['weekdays'],
  });

export type BulkCreateHolidayFormData = z.infer<typeof bulkCreateHolidaySchema>;
